import Grid from "@mui/material/Grid";

import {
  CmpTypographyField,
  CmpSelectField,
  CmpDatePickerField,
  CmpInputField,
} from "../../../Component/Common/ToolBox/ToolBox.js";
import GCAutocompleteCheckbox from "../../../Component/Common/ReuseableComponent/GCAutocompleteCheckbox";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
export default function WmsHead({
  fStatus,
  fLocation_MultiSelect,
  sLocationData,

  //multiselect
  sWebBinTransferReportData,
  sWebBetweenReportArr,

  HeadObject,
  fLocation,

  fFromDate,
  fToDate,
  fDate,
  sStatusData,
}) {
  return (
    <form id="BinTransferReportHead">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className="d-flex align-items-center "
        >
          <CmpTypographyField
            xcomponent={"h1"}
            xText={"Bin Transfer Report"}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Date"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sDate"
                xValue={HeadObject.sDate}
                xOnChange={fDate}
                xName={"sDate"}
                xData={sWebBetweenReportArr}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={true}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={4}>
              <CmpDatePickerField
                xValue={HeadObject.sFromDate}
                xOnChange={fFromDate}
                xName={"sFromDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={4}>
              <CmpDatePickerField
                xValue={HeadObject.sToDate}
                xOnChange={fToDate}
                xName={"sToDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Location"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sLocation"
                xValue={HeadObject.sLocation}
                xOnChange={fLocation}
                xName={"sLocation"}
                xData={sWebBinTransferReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={true}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"02"}
                options={sLocationData}
                xDisabled={
                  HeadObject?.sLocation?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sLocationArr}
                setValue={fLocation_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Status"} />
            </Grid>
            <Grid item xs={9} sm={9} md={3.7} lg={3.7}>
              <CmpSelectField
                xtabIndex={"24"}
                xLabelText="sStatus"
                xValue={HeadObject.sStatus}
                xOnChange={fStatus}
                xName={"sStatus"}
                xData={sStatusData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
